import { FormHelperText, Grid } from "@material-ui/core";
import React, { Component } from "react";
import { connect } from "react-redux";
import { Prompt } from "react-router";
import { Link, Redirect } from "react-router-dom";
import { bindActionCreators } from "redux";
import { userChangePasswordAction } from "../../../modules/userManagement/action";
import Button from "../../FormElement/Button";
import { validForm } from "../../FormElement/FormValidator";
import InputFiled from "../../FormElement/InputFiled";
import { getUserName } from "../../Common/CheckAuthorization";




const signInSectionStyle = {
    display: "flex",
    alignItems: "baseline",
    justifyContent: "space-between"
  };

class ChangePassword extends Component {
    constructor(props) {
        super(props);
        const userInfo = this.props.selectedUser;
        this.state = {
            successMessage: false,
            edited: false,
            userInfo: {
            password: userInfo ? userInfo.password : null,
            confirmPassword: userInfo ? userInfo.confirmPassword : null
            },
            formErrors: {
            password: ""
            },
            isInvalid: true
        };
    }

  componentWillReceiveProps(nextProps) {
    if (nextProps.userUpdated && nextProps.userUpdated !== this.props.userUpdated
      && nextProps.userUpdated.status === 200) {
      this.setState({ successMessage: true });
    }
  }

  handleSubmit = e => {
    e.preventDefault();
    this.setState({ isInvalid: true, edited: false });
    const { userInfo } = this.state;
    if(this.props.selectedUser){
    userInfo.username = this.props.selectedUser.username;
    this.props.userChangePasswordAction(userInfo,false);
    }
    else {
      userInfo.username = getUserName();
      this.props.userChangePasswordAction(userInfo,true);
    }
  };

  handleChange = event => {
    if (!this.state.edited) this.setState({ edited: true });
    const { name, value } = event.target;
    if (name === "firstName" || name === "lastName") {
      if (value.match(/^(\w|\ ){0,51}$/)) {
        this.updateState(name, value);
      }
    } else {
      this.updateState(name, value);
    }
  };

  updateState = (name, value) => {
    this.setState(
      prevState => {
        return {
          userInfo: {
            ...prevState.userInfo,
            [name]: value
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  handleError = (name, error) => {
    this.setState(
      prevState => {
        return {
          formErrors: {
            ...prevState.formErrors,
            [name]: error
          }
        };
      },
      () => {
        const { userInfo } = this.state;
        const { editMode } = this.props;
        const requiredFields = { ...userInfo };
        if (editMode) {
          delete requiredFields.password;
          delete requiredFields.confirmPassword;
        }
        this.validateAll(requiredFields);
      }
    );
  };

  validateAll = formFields => {
    this.setState({
      isInvalid: validForm(this.state.formErrors, formFields)
    });
  };

  validateResetForm = () => {
    const { password, confirmPassword } = this.state.userInfo;
    if (confirmPassword !== "" || confirmPassword !== null)
      return password === confirmPassword;
    else return true;
  };


  render() {
    const {
        password,
        confirmPassword
      } = this.state.userInfo;
    const { successMessage, edited, isInvalid } = this.state;
    const formLabel = "Change Password"
    const buttonLabel = "Update"
    if (successMessage) {
      return <Redirect to="/usermanagement" />;
    }
    return (
        <div className="">
        <Prompt when={edited} message="Changes you made may not be saved." />
        <div className="textRequired">* Required Cells</div>
        <div className="innermainform">
          <p className="loginHeader">{formLabel}</p>
          <Grid container>
          <Grid item xs={12}>
            <InputFiled
            value={password}
            label="Password"
            type="password"
            name="password"
            required
            validations={["password", "required"]}
            handleChange={this.handleChange}
            //handleError={this.handleError}
            />
            </Grid>
            <Grid item xs={12}>
                <InputFiled
                value={confirmPassword}
                label="Confirm Password"
                type="password"
                name="confirmPassword"
                required
                validations={["required"]}
                handleChange={this.handleChange}
                handleError={this.handleError}
                />
                {!this.validateResetForm() && (
                <FormHelperText>
                    <span className="error" role="alert">
                    Your password confirmation did not match your password
                    </span>
                </FormHelperText>
                )}
            </Grid>
            </Grid>
          <div className="signInSection" style={signInSectionStyle}>
            <Link to="/userManagement" style={{ color: "blue" }}>
              Cancel
            </Link>
            <Button
              disabled={isInvalid || !this.validateResetForm()}
              name={buttonLabel}
              styleClass="signIn"
              onclick={this.handleSubmit}
            />
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    selectedUser: state.userManagementReducer.selectedUser,
    userUpdated: state.userManagementReducer.userUpdated,
    SubFarmId: state.FarmManagementReducer.SubFarmId,
    MainFarmId: state.FarmManagementReducer.MainFarmId
  };
};

const mapDispatchToProps = dispatch =>
  bindActionCreators({ userChangePasswordAction }, dispatch);

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChangePassword);



// WEBPACK FOOTER //
// ./src/components/private/UserManagement/ChangePassword.js